// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.item-default {
  display: flex;
  align-items: center;
  width: 90%;
  min-height: 150px;
  max-height: 150px;
  padding: 20px;
  border-radius: 16px;
  min-width: 90%;
  box-shadow: 0px 0px 20px 0px rgba(13, 71, 161, 0.1490196078);
  margin-right: 10px;
  overflow: hidden;
}
.item-default ion-img {
  width: 30%;
  height: 100%;
}
.item-default .info {
  width: 70%;
  padding: 10px;
}
.item-default .info h3,
.item-default .info p {
  color: var(--ion-color-secondary);
  font-size: 14px;
  padding: 0px;
}
.item-default .info h3 {
  padding-bottom: 10px;
}

.item-image {
  display: flex;
  align-items: center;
  width: 90%;
  min-height: 150px;
  max-height: 150px;
  padding: 20px;
  border-radius: 16px;
  min-width: 90%;
  margin-right: 10px;
  position: relative;
  overflow: hidden;
  box-shadow: 0px 4px 10px rgba(33, 33, 33, 0.02);
}
.item-image ion-img {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  object-fit: cover;
}`, "",{"version":3,"sources":["webpack://./src/app/components/draw-news-braze-item/draw-news-braze-item.component.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,mBAAA;EACA,UAAA;EACA,iBAAA;EACA,iBAAA;EACA,aAAA;EAEA,mBAAA;EACA,cAAA;EACA,4DAAA;EAEA,kBAAA;EACA,gBAAA;AADD;AAGC;EACC,UAAA;EACA,YAAA;AADF;AAGC;EACC,UAAA;EAUA,aAAA;AAVF;AACE;;EAEC,iCAAA;EACA,eAAA;EACA,YAAA;AACH;AACE;EACC,oBAAA;AACH;;AAIA;EACC,aAAA;EACA,mBAAA;EACA,UAAA;EACA,iBAAA;EACA,iBAAA;EACA,aAAA;EAEA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,+CAAA;AAFD;AAIC;EACC,kBAAA;EACA,OAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,iBAAA;AAFF","sourcesContent":[".item-default {\n\tdisplay: flex;\n\talign-items: center;\n\twidth: 90%;\n\tmin-height: 150px;\n\tmax-height: 150px;\n\tpadding: 20px;\n\n\tborder-radius: 16px;\n\tmin-width: 90%;\n\tbox-shadow: 0px 0px 20px 0px #0d47a126;\n\n\tmargin-right: 10px;\n\toverflow: hidden;\n\n\tion-img {\n\t\twidth: 30%;\n\t\theight: 100%;\n\t}\n\t.info {\n\t\twidth: 70%;\n\t\th3,\n\t\tp {\n\t\t\tcolor: var(--ion-color-secondary);\n\t\t\tfont-size: 14px;\n\t\t\tpadding: 0px;\n\t\t}\n\t\th3 {\n\t\t\tpadding-bottom: 10px;\n\t\t}\n\t\tpadding: 10px;\n\t}\n}\n.item-image {\n\tdisplay: flex;\n\talign-items: center;\n\twidth: 90%;\n\tmin-height: 150px;\n\tmax-height: 150px;\n\tpadding: 20px;\n\n\tborder-radius: 16px;\n\tmin-width: 90%;\n\tmargin-right: 10px;\n\tposition: relative;\n\toverflow: hidden;\n\tbox-shadow: 0px 4px 10px rgba(33, 33, 33, 0.02);\n\n\tion-img {\n\t\tposition: absolute;\n\t\tleft: 0;\n\t\ttop: 0;\n\t\tright: 0;\n\t\tbottom: 0;\n\t\tobject-fit: cover;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
